import { combineReducers } from "redux";
import solr from "./solr";
import persist from "./persist"
import currentNode from "./currentNode";
import currentUser from "./currentUser";
import global from "./global";

export default combineReducers({ solr, currentNode, currentUser, global, persist });
